import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CatalogOverviewPageComponent } from '@htx/catalog';

const routes: Routes = [
  { path: '', component: CatalogOverviewPageComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CatalogRoutingModule {}
